import { Component, Prop, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import Vue from 'vue';

import config, { content } from '../../config';

import WithRender from './textpages.tpl.html';

@WithRender
@Component
export default class Textpages extends Vue {

    pages = content.pages;
    page = '';

    mounted(){
        this.getPage();
    }

    getPage(){
        const pagename = this.$route.params.name ? this.$route.params.name.toLowerCase() : this.$router.push({name: 'Performers'});
        this.page = this.pages.filter((obj: any) => obj.name === pagename)[0];
    }

    @Watch('$route')
    onRouteChange(to: Route | any, from: Route){
        this.getPage();
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/pages/textpages.ts